/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.0
 */
import React, { Fragment } from 'react';

import { FieldProps } from 'formik';
import get from 'lodash/get';

import { Input } from '@components/common';
import { EInputKind } from '@components/common/Input/Input';
import { LabelStyled } from '@components/common/Input/styled/InputStyled';
import ArrowTooltip from '@components/common/Tooltip/Tooltip';

import { ETopicAttrVisibility } from '../../types/createInquiryTypes';
import {
    ErrorMessage,
    FieldRequiredStyled,
    FormItemContainerStyled,
    FormTooltipStyled,
} from './styled/CreateInquiryFormStyled';

export interface ICreateInquiryFormTextArea {
    label: string;
    placeholder: string;
    required: boolean;
    tooltip?: string;
    visibility: ETopicAttrVisibility;
}


export const CreateInquiryFormInput = ({
                                           field,
                                           form: { touched, errors, setFieldValue },
                                           label,
                                           ...props
                                       }: FieldProps & ICreateInquiryFormTextArea) => {

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = get(e, 'target.value', '');
        setFieldValue(field.name, value);
    };
    const isError = touched[field.name] && errors[field.name];
    const kind = isError ? EInputKind.error : EInputKind.normal;
    return (
        <FormItemContainerStyled>
            <LabelStyled htmlFor={field.name} kind={kind}>
                {label}
                {
                    !!props.tooltip &&
                    <ArrowTooltip placement="top" title={props.tooltip}>
                        <FormTooltipStyled/>
                    </ArrowTooltip>
                }
                {
                    props.required &&
                    <FieldRequiredStyled>*</FieldRequiredStyled>
                }
            </LabelStyled>
            {
                props.visibility !== ETopicAttrVisibility.READ_ONLY &&
                <Fragment>
                    <Input
                        {...field}
                        {...props}
                        autoComplete="off"
                        className={field.name}
                        kind={kind}
                        placeholder={props.placeholder}
                        value={field.value || ''}
                        onChange={changeHandler}
                    />
                    {
                        isError &&
                        <ErrorMessage>
                            {
                                errors[field.name]
                            }
                        </ErrorMessage>
                    }
                </Fragment>
            }
        </FormItemContainerStyled>
    );
};
